module.exports = __webpack_public_path__ + "static/service-kv-24e8ac90db04b92e9e55a6370d87d40b.jpg";